import { render, staticRenderFns } from "./playMp4_en.vue?vue&type=template&id=c13f24fe&scoped=true&"
import script from "./playMp4_en.vue?vue&type=script&lang=js&"
export * from "./playMp4_en.vue?vue&type=script&lang=js&"
import style0 from "./playMp4_en.vue?vue&type=style&index=0&id=c13f24fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13f24fe",
  null
  
)

export default component.exports